import React from 'react';
import Icon from 'icons/Icon';
import SarFieldInfoBubbleButton from './SarFieldInfoBubble';

const SarAccordionSectionHeader = ({
  label,
  fieldPath,
  fieldType = 'Bölüm',
  infoLabel = 'Information',
  triggerIcon = 'kyc_informationicon',
  triggerClassName = 'text-f-black-2 hover:opacity-50 opacity-100 transition-opacity duration-200',
  hasError = false,
}: SarAccordionSectionHeaderProps): JSX.Element => {
  const finalTriggerClassName = hasError ? 'text-f-red-1 hover:opacity-50 opacity-100 transition-opacity duration-200' : triggerClassName;
  const finalInfoLabelClassName = hasError ? 'text-xs tracking-wide text-f-red-1' : 'text-xs tracking-wide text-f-black-2';

  return (
    <div className={'flex flex-col'}>
      <div className={'flex items-center gap-x-1 justify-start'}>
        <span className={finalInfoLabelClassName}>{infoLabel}</span>
        <SarFieldInfoBubbleButton
          fieldPath={fieldPath}
          fieldLabel={label}
          fieldType={fieldType}
          trigger={<Icon icon={triggerIcon} className={finalTriggerClassName} />}
        />
      </div>
      <span className={`text-sm font-semibold ${hasError ? 'text-f-red-1' : 'text-[#1D2932]'}`}>{label}</span>
    </div>
  );
};

interface SarAccordionSectionHeaderProps {
  label: string;
  fieldPath: string;
  fieldType?: string;
  infoLabel?: string;
  triggerIcon?: string;
  triggerClassName?: string;
  hasError?: boolean;
}

export default SarAccordionSectionHeader;
